// eslint-disable-next-line
let scroll = new SmoothScroll('[smoothscroll]', {
  speedAsDuration: true,
  speed: 700,
  after: function () {
    ScrollTrigger.refresh(); // スムーススクロール後にリフレッシュ
  }
});


document.querySelectorAll('.business__box').forEach(function(box) {
  const swiperEl = box.querySelector('.mySwiper');
  if (!swiperEl) return;

  // PC判定
  const isPC = window.innerWidth > 768;

  new Swiper(swiperEl, {
    loop: true,

    // PC/SP で動作分岐
    allowTouchMove: !isPC,        // PC = false, SP = true
    slidesPerView: isPC ? 1.3 : 1.1,
    spaceBetween: isPC ? '3%' : '3%', // そのまま使う

    mousewheel: false,

    navigation: {
      nextEl: box.querySelector('.swiper-button-next'),
      prevEl: box.querySelector('.swiper-button-prev'),
    },
  });
});


$(window).on("load", function () {

  $('.popup-modal').magnificPopup({
    type: 'inline',
    showCloseBtn: false,
    fixedContentPos: true,
    mainClass: 'mfp-zoom-in',
    removalDelay: 400,
    callbacks: {
      open: function () {

        // 閉じるボタン
        $('.group-modal__close').on('click', function (e) {
          e.preventDefault();
          $.magnificPopup.close();
        });
      },
    }
  });
});

$('.label').each(function () {
  const text = $(this).text();
  if (text.includes('（') || text.includes('）')) {
    $(this).addClass('-narrow');
  }
});




$(function () {
  let $areaButtons = $('.js-filter-area button');
  let $jobButtons  = $('.js-filter-job button');
  let $items       = $('.research__items');

  // 選択中の条件
  let selectedAreas = ['all'];
  let selectedJobs  = ['all'];

  // ======= フィルタ本体（AND検索） =======
  function filterItems() {
    let areaAll = selectedAreas.includes('all');
    let jobAll  = selectedJobs.includes('all');

    $items.each(function () {
      let $item = $(this);

      let areas = ($item.attr('data-area') || '').split(/\s+/).filter(Boolean);
      let jobs  = ($item.attr('data-job')  || '').split(/\s+/).filter(Boolean);

      let matchArea =
        areaAll || selectedAreas.some(function (a) { return areas.includes(a); });

      let matchJob =
        jobAll || selectedJobs.some(function (j) { return jobs.includes(j); });

      if (matchArea && matchJob) {
        $item.show();
      } else {
        $item.hide();
      }
    });
  }

  // ======= 勤務地タブ（複数選択） =======
  $areaButtons.on('click', function () {
    let $btn = $(this);
    let value = $btn.data('area');

    if (value === 'all') {
      selectedAreas = ['all'];
      $areaButtons.removeClass('is-active');
      $btn.addClass('is-active');
    } else {
      $btn.toggleClass('is-active');

      selectedAreas = selectedAreas.filter(function (v) { return v !== 'all'; });

      if ($btn.hasClass('is-active')) {
        if (!selectedAreas.includes(value)) selectedAreas.push(value);
      } else {
        selectedAreas = selectedAreas.filter(function (v) { return v !== value; });
      }

      if (selectedAreas.length === 0) {
        selectedAreas = ['all'];
        $areaButtons.removeClass('is-active');
        $areaButtons.filter('[data-area="all"]').addClass('is-active');
      } else {
        $areaButtons.filter('[data-area="all"]').removeClass('is-active');
      }
    }

    filterItems();
  });

  // ======= 職種タブ（複数選択） =======
  $jobButtons.on('click', function () {
    let $btn = $(this);
    let value = $btn.data('job');

    if (value === 'all') {
      selectedJobs = ['all'];
      $jobButtons.removeClass('is-active');
      $btn.addClass('is-active');
    } else {
      $btn.toggleClass('is-active');

      selectedJobs = selectedJobs.filter(function (v) { return v !== 'all'; });

      if ($btn.hasClass('is-active')) {
        if (!selectedJobs.includes(value)) selectedJobs.push(value);
      } else {
        selectedJobs = selectedJobs.filter(function (v) { return v !== value; });
      }

      if (selectedJobs.length === 0) {
        selectedJobs = ['all'];
        $jobButtons.removeClass('is-active');
        $jobButtons.filter('[data-job="all"]').addClass('is-active');
      } else {
        $jobButtons.filter('[data-job="all"]').removeClass('is-active');
      }
    }

    filterItems();
  });

  // 初期表示
  filterItems();
});
